<template>
  <div style="height: 228px" id="left-echarts-02"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {
    var chartDom = document.getElementById("left-echarts-02");
    var myChart = echarts.init(chartDom);
    var option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985",
          },
        },
      },
      legend: {
        data: ["鸡蛋"],
        textStyle: {
          color: "white",
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "3%",
        top: "25%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          data: ["1月", "2月", "3月", "4月", "5月", "6月"],
          axisLabel: {
            color: "white",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          // name: "元/斤",
          nameTextStyle: {
            color: "white",
          },
          axisLabel: {
            color: "white",
            formatter: "{value}元/斤",
          },
        },
      ],
      series: [
        {
          name: "鸡蛋",
          type: "line",
          smooth: true,
          lineStyle: {
            width: 4,
          },
          tooltip: {
            valueFormatter: function (value) {
              return value + "元/斤";
            },
          },
          emphasis: {
            focus: "series",
          },
          data: [4.5, 4.7, 4.6, 4.8, 4.7, 4.6],
        },
      ],
    };
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
